// extracted by mini-css-extract-plugin
module.exports = {"service_wrapper":"_927a99ad28--service_wrapper--U2UoK","service_name":"_927a99ad28--service_name--26eTW"};